import React from 'react';
import Modal from 'react-bootstrap/Modal'
import {useDispatch, useSelector} from "react-redux";
import {deleteSale, setDeleteSaleId} from "../../actions/sale";

const SaleDeleteForm = () => {

    const dispatch = useDispatch();

    const {delete_sale, currentPage, numberOfPages, sales} = useSelector(state => state.sale);

    const closeModal = () =>{
        dispatch(setDeleteSaleId(null))
    };

    let getPage = null;

    const onConfirm = () =>{

        if ((currentPage === numberOfPages) && (sales.length === 1) ){
            getPage = (currentPage - 1);
        }
        else{
            getPage = currentPage;
        }
        dispatch(deleteSale(delete_sale.id, getPage))
    };

    let condition = false;
    if(delete_sale !== null)
        condition = true;

    return (
        <div>
            <Modal show={condition} onHide={closeModal}>
                <Modal.Header className="bg-danger" closeButton>
                    <Modal.Title className="text-white" >Sotuvchi o'chirish</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Siz haqiqatdan ham ushbu sale ni o'chirmoqchimisiz ?
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={closeModal} className="btn btn-secondary">YO'Q</button>
                    <button onClick={onConfirm} className="btn btn-primary">HA</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default SaleDeleteForm;